
import { toast } from "sonner";
import { useToast as useShadcnToast } from "@/hooks/use-toast";

// Экспортируем toast из sonner и useToast из hooks для совместимости
export { toast };
export const useToast = useShadcnToast;
